import SettingsSlider, {
  SettingSliderProps,
} from "@app/analytics/account/components/SettingsSlider";
import UpsellTooltipWrapper from "@app/analytics/components/UpsellTooltipWrapper";
import { PartialBy } from "@app/common/types";
import { EnterpriseRole } from "@app/common/workspaces/types";

const SLIDER_OPTIONS = [
  { label: "Admin", value: "admin" },
  { label: "Manager", value: "manager" },
  { label: "User", value: "member" },
];

interface WorkspaceRoleSliderProps
  extends PartialBy<SettingSliderProps, "selected" | "options"> {
  role: EnterpriseRole;
}

const WorkspaceViewRoleSlider = ({
  disabled,
  role,
  ...sliderProps
}: WorkspaceRoleSliderProps) => {
  return (
    <UpsellTooltipWrapper show={disabled}>
      <SettingsSlider
        disabled={disabled}
        {...sliderProps}
        options={SLIDER_OPTIONS}
        selected={role as string}
      />
    </UpsellTooltipWrapper>
  );
};

export default WorkspaceViewRoleSlider;
